<template>
  <div class="comment-box">
    <div class="comment-title">全部评论</div>
    <div class="comment-ul" v-if="commentList.length > 0">
      <div class="comment-li" v-for="(item, index) in commentList" :key="index">
        <div class="comment-top">
          <img v-if="item.avatar" :src="item.avatar.url" alt="" />
          <img v-else src="@/assets/images/defaultHead.png" alt="">
          {{ item.nickname }}
        </div>
        <div class="comment-text">{{ item.content }}</div>
        <div class="comment-time">{{ item.createTimeFormat }}</div>
        <div class="operation-box">
          <!-- <div class="operation-bt">
            <img src="@/assets/images/qz1.png"/>
            0
          </div>
          <div class="operation-bt">
            <img src="@/assets/images/qz2.png"/>
            0
          </div> -->
        </div>
      </div>
    </div>
    <empty class="empty-margin" v-if="commentList.length <= 0"></empty>
  </div>
</template>

<script>
import empty from "@/components/empty/index";
export default {
  name: "comment",
  components: { empty },
  data() {
    return {
    }
  },
  props: {
    commentList: {
      type: Array,
      default: () => {
        return []
      },
    }
  },
}
</script>

<style lang="less" scoped>
.empty-margin {
  padding: 40px 0;
}

.comment-box {
  background: #fff;
  border-radius: 6px;
  margin-top: 50px;

  .comment-title:before {
    content: '';
    display: block;
    width: 96px;
    height: 3px;
    bottom: 0px;
    position: absolute;
    left: 16px;
    background: rgba(189, 24, 30, 1);
  }

  .comment-title {
    position: relative;
    line-height: 52px;
    padding: 0 28px;
    border-bottom: 1px solid rgba(230, 230, 230, 1);
    text-align: left;
    color: #222222;
    font-size: 18px;
    font-weight: bold;
  }

  .comment-ul {
    padding: 0 34px;
    padding-top: 15px;
  }

  .comment-li:last-child {
    border: none;
  }

  .comment-li {
    text-align: left;
    padding: 20px 0;
    border-bottom: 0.5px solid rgba(229, 230, 235, 1);
    position: relative;

    .operation-box {
      position: absolute;
      display: flex;
      align-items: center;
      bottom: 20px;
      right: 0px;

      .operation-bt:hover {
        color: rgba(189, 24, 30, 1);
      }

      .operation-bt {
        display: flex;
        align-items: center;
        color: #999999;
        font-size: 12px;
        margin-left: 20px;
        cursor: pointer;

        img {
          width: 14px;
          margin-right: 4px;
        }
      }
    }

    .comment-top {
      display: flex;
      align-items: center;
      color: #222222;
      font-size: 14px;
      font-weight: bold;

      img {
        width: 26px;
        height: 26px;
        border-radius: 50%;
        overflow: hidden;
        margin-right: 6px;
      }
    }

    .comment-text {
      color: rgba(34, 34, 34, 1);
      font-size: 15px;
      margin-top: 10px;
      line-height: 24px;
    }

    .comment-time {
      color: #999999;
      font-size: 12px;
      line-height: 12px;
      margin-top: 12px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/base/comment.vue